import * as ApiManager from './_manager'

export const auth = {

    login: (payload) => {
        return ApiManager.callApi('/guest/auth/login', payload)
    },

    verifyOtp: (payload) => {
        return ApiManager.callApi('/guest/auth/avails/verify', payload)
    },

    logout: (payload) => {
        return ApiManager.callApi ('/guest/auth/logout', payload);
    },

    deletePreviousSession: (payload) => {
        return ApiManager.callApi('/guest/auth/deletePreviousSession', payload);
    }
}
